import {dataActions} from '../../actions'
import {dataConstants} from '../../constants'

// dataFetchProps maps slices of the Redux store to props in the connect HOC
// Use this in place of mapStateToProps on connected components
export function dataFetchProps(state) {
    return {
        loggedIn: state.authentication.loggedIn,
        checkingLoginStatus: state.authentication.checkingLoginStatus,
        token: state.authentication.token,
        eventcategoryLoading: state.eventcategorydata.fetchingEventCategory,
        loadingSetEventCategory:
            state.seteventcategorydata.loadingSetEventCategory,
        eventcategorylist: state.eventcategorydata.eventcategorylist,
        eventcategory: state.seteventcategorydata.eventcategory,
        swipeteams: state.swipeteamdata.swipeteamdata,
        engagementtypedata: state.engagementtypedata.engagementtypelist,
        departmentsdata: state.departmentsdata.departmentslist,
        activedepartment: state.departmentsdata.activedepartment,
        error:
            state.eventcategorydata.errors.length > 0 ||
            state.seteventcategorydata.errors.length > 0,
    }
}

// Dispatch actions to store for data fetches.
// Use this in place of mapDispatchToProps on connected components
export const dataFetches = {
    eventcategoryFetchRequest: (token, deptId) =>
        dataActions.eventcategoryFetchRequest(token, deptId),
    //eventoccurGetRequest: payload => dataActions.eventoccurGetRequest(payload),
    swipeteamsFetchRequest: (token, activedepartment) =>
        dataActions.swipeteamsFetchRequest(token, activedepartment),
    engagementtypeRequest: token => dataActions.engagementtypeRequest(token),
    departmentsDataRequest: token => dataActions.departmentsDataRequest(token),
}

// This function uses the fetchrequests parameter to call functions in dataFetches{} object
export function calldataFetches(props, fetchrequests) {
    const {
        token,
        activedepartment,
        eventcategoryFetchRequest,
        //eventoccurGetRequest,
        swipeteamsFetchRequest,
        engagementtypeRequest,
        departmentsDataRequest,
    } = props

    const iterator = fetchrequests.values()

    for (const value of iterator) {
        switch (value) {
            case dataConstants.EVENT_CATEGORIES:
                if (activedepartment) {
                    eventcategoryFetchRequest(token, activedepartment)
                }
                break
            case dataConstants.EVENT_OCCURRENCES:
                //eventoccurGetRequest(payload)
                break
            case dataConstants.EVENT_ENGAGEMENTTYPES:
                engagementtypeRequest(token)
                break
            case dataConstants.EVENT_SWIPETEAMS:
                if (activedepartment) {
                    swipeteamsFetchRequest(token, activedepartment)
                }
                break
            case dataConstants.EVENTS_DEPARTMENTS:
                departmentsDataRequest(token)
                break
            default:
                break
        }
    }
}
